<template>
    <span :style="styleObj" @click="clickHandle">
      <slot></slot>
    </span>
</template>

<script>
import { loadImage } from "@/utils"
export default {
  props: {
    mediaInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      styleObj: {}
    }
  },

  watch: {
    mediaInfo: {
        handler(value = {}) {
            if (!value.url) return
            loadImage(value.thumbnail_url, 1, 3).then(res => {
                if (res) {
                    this.imgUrl = value.thumbnail_url
                } else {
                    this.imgUrl = value.url
                }

                const imgUrl = res ? value.thumbnail_url : (value.url || value.thumbnail_url)

                this.styleObj = {
                    background: `#f5f5f5 url(${imgUrl}) no-repeat center center`,
                    backgroundSize: "cover",
                    cursor: "pointer"
                }
            })
        },
        immediate: true,
        deep: true,
    }
  },

  methods: {
    clickHandle () {
      this.$emit("click")
    }
  }
}
</script>
